import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-prompt-compact',
  templateUrl: './prompt-box-compact.component.html'
})
export class PromptBoxCompactComponent {
  @Input() boxStyle?: string;
  @Input() title: string;
  @Input() iconClass: string = 'bi bi-cloud-upload';
  @Input() url?: string;
  @Input() linkText?: string;
}
